import * as React from 'react'

export const RuntimeFabricSettingsIcon = () => {
    return (
      <svg width="65" height="70" viewBox="0 0 65 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M48.75 29.115V54.8825L53.75 51.3825V32.6175L48.75 29.115Z" fill="#087299"/>
        <path d="M36.455 21.01H36.25V54.8825L41.25 51.3825V24.3675L36.455 21.01Z" fill="#00A3E0"/>
        <path d="M23.955 33.51H23.75V55.6325L28.75 52.1325V36.8675L23.955 33.51Z" fill="#00A3E0"/>
        <path d="M11.25 9.11499V55.885L16.25 52.3825V12.6175L11.25 9.11499Z" fill="#087299"/>
        <circle cx="49.5" cy="57.5" r="12" fill="white" stroke="#7DCEEC"/>
        <path d="M45 58.6L48.2 61L53.8 53" stroke="#00A2DF" strokeWidth="2"/>
      </svg>
    )
}
